<template>
  <form
    @submit.prevent="$emit('create-thread-step-2')"
    class="messages-participants"
  >
    <div class="messages-participants-label">
      {{ $t("threads.chatMembers") }}:
    </div>
    <ul class="messages-current-participants">
      <li
        v-for="participant in currentParticipants"
        :key="participant.id"
        :style="{
          'background-image': participant.avatar
            ? 'url(' + participant.avatar + ')'
            : '',
        }"
        class="messages-current-participant"
        :class="{ 'no-avatar': !participant.avatar }"
      ></li>
    </ul>
    <div v-if="participantsError" class="v-error messages-participants-error">
      <span>{{ $t("threads.chooseTwoInterlocutors") }}</span>
    </div>
    <input
      type="text"
      :placeholder="$t('threads.username')"
      v-model="search"
      @input="searchParticipants"
      class="messages-search-participants input"
    />
    <div class="messages-available-participants-wrapper">
      <div v-bar class="messages-available-participants">
        <div>
          <ul class="messages-available-participants-list">
            <li
              v-for="(friend, index) in friends"
              :key="friend.id"
              :ref="'element' + index"
              class="user-item messages-available-participant"
            >
              <router-link
                :to="'/profile/' + friend.id"
                class="user-item-avatar"
                :style="{
                  'background-image': friend.avatar
                    ? 'url(' + friend.avatar + ')'
                    : '',
                }"
                :class="{ 'no-avatar': !friend.avatar }"
              ></router-link>
              <div class="user-item-info">
                <router-link
                  :to="'/profile/' + friend.id"
                  class="user-item-title"
                  >{{ friend.name }}</router-link
                >
                <button
                  v-if="checkParticipant(friend.id)"
                  @click="$emit('remove-participant', friend.id)"
                  type="button"
                  class="user-item-button button-secondary"
                >
                  {{ $t("threads.delete") }}
                </button>
                <button
                  v-else
                  @click="$emit('add-participant', friend)"
                  type="button"
                  class="user-item-button button"
                >
                  {{ $t("threads.add") }}
                </button>
              </div>
            </li>
            <li v-if="moreLoader"><button class="button-loader"></button></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="messages-participants-buttons">
      <button
        v-if="saveLoader"
        type="button"
        class="button button-loader messages-create-button"
      ></button>
      <button v-else type="submit" class="button messages-create-button">
        {{ $t("threads.save") }}
      </button>
      <button
        @click="$emit('cancel-create-thread')"
        type="button"
        class="button-secondary messages-create-button"
      >
        {{ $t("threads.cancel") }}
      </button>
    </div>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import { observeListEnd } from "@/mixins/observeListEnd";

export default {
  name: "ThreadParticipants",
  props: {
    currentParticipants: {
      type: Array,
      required: true,
    },
    participantsError: {
      type: Boolean,
      required: true,
    },
    saveLoader: {
      type: Boolean,
      required: true,
    },
  },
  mixins: [observeListEnd],
  data() {
    return {
      search: "",
      moreLoader: false,
      observer: null,
      moreIndex: 0,
    };
  },
  computed: {
    ...mapGetters({
      friends: "friends/fetchFriends",
      friendsNext: "friends/fetchFriendsNext",
    }),
  },
  created() {
    this.getFriends();
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting === true) {
          this.showMore();
        }
      },
      { threshold: [0] }
    );
  },
  methods: {
    getFriends(query = false) {
      this.$store.dispatch("friends/get", query ? query : false).then(() => {
        this.updateMoreIndex();
        this.observeListEnd("element");
      });
    },
    searchParticipants() {
      if (this.search.length >= 3) {
        this.getFriends(encodeURIComponent(this.search));
      } else if (this.isSearch) {
        this.getFriends();
      }
    },
    checkParticipant(id) {
      let pos = this.currentParticipants
        .map(function (e) {
          return e.id;
        })
        .indexOf(id);
      return pos != -1;
    },
    updateMoreIndex() {
      this.moreIndex = this.friends.length - 2;
    },
    showMore() {
      if (this.friendsNext) {
        this.moreLoader = true;
        this.$store
          .dispatch("friends/getNext")
          .then(() => {
            this.observeListEnd("element", false, true, true);
            this.moreLoader = false;
          })
          .catch(() => {
            this.moreLoader = false;
          });
      } else {
        this.observeListEnd("element", false, true);
      }
    },
  },
};
</script>
